<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="1200x580"
      :visible.sync="modalVisible"
      :contentStyle="contentStyle"
      class="message-dialog"
  >
    <template #content>
      <gj-icon class="iconfont iconguanbi-da" @click.native="cancel"></gj-icon>
      <div class="message-warp">
        <div class="message-left">
          <gj-area-title font-size="20px">版本更新公告</gj-area-title>
          <div class="message-header">消息中心全新改版升级</div>
          <div class="header-content">
            运营消息中心全面升级，自定义预警规则、公众号同步推送、紧急情况可以实时通知，运营人员再也不用担心漏掉重要指标与异常情况！
          </div>

            <div v-for="(val,ind) in messageList" :key="ind" class="content-inner">
              <div class="inner-title" :class="ind % 2 === 0 ? 'before-blue' : 'before-orange'">{{val.title}}</div>
              <div class="inner-content">{{val.content}}</div>
          </div>

          <div class="notes">
            注：消息仅在停用状态才能编辑设置规则
          </div>

        </div>
        <div class="message-right">
          <img :src="imageUrl" />

          <el-button class="know-btn" @click="cancel" type="primary" size="small">
            我知道了
          </el-button>
        </div>

      </div>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn} from "@/minxins";

export default {
  name: "message-center",
  mixins: [modalMixIn],
  data(){
    return{
      messageList:[
        {title:'5个消息类型、支持18中消息内容', content:'商品预警、店铺绩效预警、差评预警、数据指标预警、订单配送费异常预警'},
        {title:'部分消息支持自定义设置预警规则', content:'部分消息自定义设置指针计算方式、数值、推送时间'},
        {title:'支持PC、公众号同时推送', content:'自定义设置推送渠道，后续将支持APP推送'},
        {title:'推送权限可以自定义设置', content:'设置推送关联人员、或指定某人'},
      ],
      imageUrl: require('@/assets/images/messageDialog.png'),
      contentStyle:{height: '100%'}
    }
  },
  methods: {
    cancel() {
      this.modalVisible = false;
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/assets/styles/variables.scss';

.message-dialog {
  /deep/ .v-modal {
    margin-top: 0 !important;
    margin-left: 0 !important;
    opacity: 0.8 !important;
  }

  /deep/ .gj-modal{
    margin-top: 0 !important;
  }

  /deep/ .gj-modal--vertical{
    margin-left: 0;
  }

  /deep/ .el-dialog__body {
    padding: 0 !important;
  }

  .iconguanbi-da {
    position: absolute;
    top: 18px;
    right: 20px;
    font-size: 14px;
    cursor: pointer;
    z-index: 10;
  }

  .message-warp {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    box-sizing: border-box;

    .message-left {
      width: 450px;
      padding: 48px 54px 48px 80px;
      box-sizing: border-box;
      height: 100%;

      .message-header{
        color: #333;
        font-size: 28px;
        line-height: 40px;
        font-weight: bold;
        margin: 16px 0 12px 0;
      }

      .header-content{
        font-size: 12px;
        color: #666;
        line-height: 18px;
        padding-right: 30px;
        margin-bottom: 20px;
      }

      .content-inner{
        padding-left: 26px;
        color: #333;
        margin-bottom: 20px;
        .inner-title{
          font-size: 16px;
          line-height: 22px;
          font-weight: 500;
          position: relative;
          margin-bottom: 8px;

          &::before{
            content: '';
            display: block;
            position: absolute;
            width: 16px;
            height: 16px;
            border-radius: 4px;
            top: 3px;
            left: -26px;
          }
        }

        .before-blue{
          &::before{
            background: #1F6EEF;
          }
        }

        .before-orange{
          &::before{
            background: #EF6A1F;
          }
        }

        .inner-content{
          font-size: 12px;
          line-height: 16px;
          font-weight: 400;
        }
      }

     .notes{
       line-height: 20px;
       font-size: 14px;
       color: #EF4337;
     }
    }

    .message-right {
      width: 750px;
      height: 100%;
      position: relative;

      >img{
        width: 100%;
        height: 100%;
      }

      .know-btn{
        position: absolute;
        bottom: 18px;
        right: 26px;
        //font-size: 12px;
        //color: #fff;
        //padding: 8px 24px;
        //border-radius: 2px;
        //background: #1F6EEF;
        //cursor: pointer;
      }
    }
  }
}
</style>
